'use strict';

angular.module('docketbook')
.controller('companySettingsChecklistsController', function($scope, docketService, $window, splitListInterface, uuid, Restangular, $state, $stateParams, accessControl, $q) {
  mixpanel.track("Opened CompanySettings-Checklists Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.templateEdit = null;

  $scope.newField = {};
  $scope.selected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'name'
  };
  $scope.listCount = 0;

  $scope.splitListFunc = new splitListInterface($scope);

  $scope.goTo = function(href) {
    $window.location.href = href;
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************/
  /**** List Controls *****/
  /************************/

  $scope.loadChecklistsList = function() {
    $scope.promise = $q(function(resolve, reject) {
      // Get templates from docketService
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      docketService.getChecklistTemplates(queryParams, function(checklists) {
        $scope.allChecklistTemplates = checklists;
        if ( queryParams.offset <= 0 && checklists.length < queryParams.limit ) {
          $scope.listCount = checklists.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function(error) {
        $scope.allChecklistTemplates = [];
        reject('Error');
      });
    });
  }

  $scope.loadChecklistsList();

  /*******************************/
  /***** Checklist templates *****/
  /*******************************/

  $scope.newTemplate = function() {
    $scope.templateEdit = { 'fields' : [] };
    $("#newTemplateModal").fadeIn(100);
  }

  $scope.closeTemplateEdit = function() {
    $scope.templateEdit = null;
    //$("#newTemplateModal").fadeOut(100);
  }

  $scope.editTemplate = function(template) {
    $scope.templateEdit = template;
    $scope.templateOriginal = angular.copy(template);
    //$("#newTemplateModal").fadeIn(100);
  }

  $scope.saveTemplate = function(template, cb) {
    template.loading = true;
    docketService.saveChecklistTemplate(template, function(templateUpdated) {
      $scope.loadChecklistsList();
      $scope.templateEdit = null;
      $scope.closeTemplateEdit();

    }, function(err) {
      template.loading = false;
      $scope.alertService.presentAutoAlert('saveChecklistTemplate', err);
    });
  }

  $scope.removeFieldFromTemplate = function(field, template) {
    var index = template.fields.indexOf(field);
    if ( index != -1 ) {
      template.fields.splice(index, 1);
    }
  }

  $scope.addBlankFieldToTemplate = function(template) {
    if ( template.fields == null ) {
      template.field = [];
    }
    var newField = {};
    newField.id = uuid.v4();
    template.fields.push(newField);
  }

  $scope.addFieldToTemplate = function(field, template) {
    if ( template.fields == null ) {
      template.fields = [];
    }
    // generate a uuid for the field
    field.id = uuid.v4();
    template.fields.push(field);
    $scope.newField = {};
  }

  $scope.configureTemplate = function(template) {
    $scope.templateConfigure = template;
    $scope.templateOriginal = angular.copy(template);
    $scope.splitListFunc.slideTableListDetailOpen();
  }

  $scope.saveNewTemplateConfig = function(template) {
    // iterate over list items and get new order
    var fieldOrder = [];
    $(".blockFieldItem").each(function() {
      if ( $(this).attr('id') != null ) {
        var fieldId = $(this).attr('id');
        for ( var i = 0; i < template.fields.length; i++ ) {
          if ( template.fields[i].id == fieldId ) {
            fieldOrder.push(template.fields[i]);
            break;
          }
        }
      }
    });

    template.fields = fieldOrder;
    template.loading = true;
    $scope.saveTemplate(template, function() {
      template.loading = false;
      $scope.loadChecklistsList();
    });
  }

  $scope.deleteSelectedChecklists = function() {
    var count = $scope.selected.length;
    swal({
			title: "Are you sure?",
			text: count + " checklists will be deleted.",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
        docketService.deleteBulkChecklistTemplates($scope.selected, function(failures) {
          if ( failures && failures.length > 0 ) {
            $scope.alertService.presentAutoAlert('deleteBulkChecklists', {status:202, requestName: 'Delete bulk checklists - failures ' + failures.length + ' of ' + $scope.selected.length});
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkChecklists', {status:200});
          }
          $scope.loadChecklistsList();
        });
			}
		});
  }

});



// WEBPACK FOOTER //
// ./src/controllers/companySettings/checklists.js